import { AppState } from 'src/app/core/core.state'
import { ResourceEffects } from 'src/app/shared/resource-effects'

import { Injectable } from '@angular/core'
import { Actions } from '@ngrx/effects'
import { Store } from '@ngrx/store'

import { CompetitionMatch } from './competition-match'
import { competitionMatchActions } from './competition-match.actions'
import * as fromCompetitionMatch from './competition-match.reducer'
import { CompetitionMatchService } from './competition-match.service'

@Injectable()
export class CompetitionMatchEffects extends ResourceEffects<CompetitionMatch> {
  constructor(
    public actions$: Actions,
    public store: Store<AppState>,
    public competitionMatchService: CompetitionMatchService
  ) {
    super(
      fromCompetitionMatch.FEATURE_NAME,
      competitionMatchService,
      competitionMatchActions,
      actions$
    )
  }
}
